import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetProfilesRequest } from '@cash-web/shared-util-protos/squareup/cash/janus/api/AccountholderProfile.pb'
import { GetProfilesResponse } from '@cash-web/shared-util-protos/squareup/cash/janus/api/AccountholderProfile.pb'

export const getProfiles = (request: GetProfilesRequest, options?: CashRequestOptions) =>
  post<GetProfilesRequest, GetProfilesResponse>('/2.0/cash/get-profiles', request, { ...options, rejectOnError: true })
